/**
 * Action types for breadcrumbs functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle breadcrumbs action.
 */

export const UPDATE_BREADCRUMBS_STATE = 'UPDATE_BREADCRUMBS_STATE';

/**
 * Array of common navigation URL
 */
export const BREADCRUMBS_URL = {
	DASHBOARD: [
		{ content: 'Home', link: '#', isCurrent: true },
	],
	MAINTENANCE: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{ content: 'Maintenance', link: null, isCurrent: true },
	],
	TOPOLOGY: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{ content: 'Sites', link: '/topology', isCurrent: true },
	],
	IOPASS: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{ content: 'io Pass', link: null, isCurrent: true },
	],
	TEMPLATE: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{ content: 'Templates', link: null, isCurrent: true },
	],
	SYSTEM: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{ content: 'Canvas Settings', link: null, isCurrent: true },
	],
	ACCOUNT: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{ content: 'Account Details', link: null, isCurrent: true },
	],
	PASSWORD2FA: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		{
			content: 'Password & 2FA',
			link: null,
			isCurrent: true,
		},
	],
	ACCESSPOINTDASHBOARD: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		// {
		// 	content: 'Manage',
		// 	link: '',
		// 	isCurrent: false,
		// },
	],
	SWITCH_DASHBOARD: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		// {
		// 	content: 'Manage',
		// 	link: null,
		// 	isCurrent: false,
		// },
	],
	EACH_CLIENT_DASHBOARD: [
		{ content: 'Home', link: '/dashboard', isCurrent: false },
		// {
		// 	content: 'Manage',
		// 	link: null,
		// 	isCurrent: false,
		// },
	],
};
